<template>
	<div class="extend-to-bottom" ref="bottomSection" v-if="showFooter">
		<v-dialog />
		<BaseActions class="margin-bottom" :actions="getCheckoutActionsBottom()" />
		<order-button />
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import paymentMixin from '@Mixin/paymentMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	import accountMixin from '@Mixin/accountMixin';
	import alertMixin from '@Mixin/alertMixin';

	const OrderButtonVue = (resolve) => {
		require.ensure([], () => {
			resolve(require('@Checkout/CheckoutView/OrderButton.vue'));
		});
	};
	export default {
		mixins: [
			paymentMixin,
			navigationMixin,
			accountMixin,
			alertMixin
		],
		components: {
			'order-button': OrderButtonVue,
		},
		data() {
			return {
				showPaymentError: false,
			}
		},
		computed: {
			isMobile() {
				return this.$mq !== 'desktop';
			},
			showFooter() {
				const isCheckout = (this.$route.name === 'checkout');
				const checkout = this.$appConstants.checkout;
				const isMinimal = (checkout.minimal === '1') ? true : false;
				return (this.isMobile && isCheckout && isMinimal);
			},
			paymentMethodDisabled() {
				return this.isNoLogin;
			},
		},
		methods: {
			handlePaymentAction() {
				if (this.paymentMethodDisabled) {
					// show alert
					this.customAlert(
						'Select Payment',
						'Please sign in with an account or continue as a guest.',
						{
							title: 'Sign In',
							handler: () => {
								this._setBackRoute({
									path: '/checkout'
								});
								this._navigateToSignIn();
								this.$modal.hide('dialog');
							},
						},
						{
							title: 'Guest',
							handler: () => {
								this._setBackRoute({
									path: '/checkout'
								});
								this._navigateToGuestForm();
								this.$modal.hide('dialog');
							},
						},
						{
							title: 'Cancel',
						},
					);
					return;
				}
				this._navigateToPaymentChooser();
			},
			getCheckoutActionsBottom() {
				return [
					{
						name: 'Payment Method',
						value: this.displayPaymentMethod,
						accessory: 'backChevron',
						flip: true,
						clickHandler: this.handlePaymentAction,
						disabled: this.paymentMethodDisabled,
						error: this.showPaymentError,
					},
				];
			},
			onPaymentError() {
				this.showPaymentError = true;
			},
			onPaymentValid() {
				this.showPaymentError = false;
			},
		},
		created() {
			EventBus.$on('payment-error', this.onPaymentError);
			EventBus.$on('payment-valid', this.onPaymentValid);
		},
		destroyed() {
			EventBus.$off('payment-error');
			EventBus.$off('payment-valid');
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.extend-to-bottom {
		display: flex;
		flex-direction: column;
		position: fixed;
		left: 0;
		bottom: 0;
		padding-bottom: 60px;
		padding-right: 0;
		border-top: 1px solid $greyOutline;
		z-index: 100;

		width: 100%;
		background-color: $landingPageBackground;
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/checkout/MobileCheckoutFooter.vue